
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea073"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea073"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gzR1g", function(module, exports) {

$parcel$export(module.exports, "NewWebsocket", () => $d6bb929f44edcadb$export$ebe14be6c9426645);
const $d6bb929f44edcadb$var$ROOT_URL = 'https://backend-files-public.liveresultater.no/';
const $d6bb929f44edcadb$var$urlParams = new URLSearchParams(window.location.search);
const $d6bb929f44edcadb$var$FORCED_INTERVAL_STR = $d6bb929f44edcadb$var$urlParams.get('opdt');
let $d6bb929f44edcadb$var$forcedInterval = Number.parseInt($d6bb929f44edcadb$var$FORCED_INTERVAL_STR);
if (!Number.isNaN($d6bb929f44edcadb$var$forcedInterval)) // Ensure that we do not go below one second.
$d6bb929f44edcadb$var$forcedInterval = Math.max(1, $d6bb929f44edcadb$var$forcedInterval);
class $d6bb929f44edcadb$export$ebe14be6c9426645 {
    Close() {
        this.killed = true;
    }
    constructor(collectionId, collectionsToTrigger, listenSseEvents){
        this.sseEventsEstablished = false;
        this.lastPartHandled = new Map();
        this.killed = false;
        this.hashOfLastManifest = '';
        this.collectionId = collectionId;
        this.collectionsToTrigger = collectionsToTrigger;
        this.GetData();
        if (listenSseEvents) this.ListenSseEvents();
    }
    // Listen for SSE (server-sent events) to get notified of changes. This is a fast-path to get updates
    // without polling. When SSE is established, we reduce our polling frequency, but keep it as a fallback.
    ListenSseEvents() {
        const eventSource = new EventSource("https://sse.liveresultater.no/events/" + this.collectionId);
        eventSource.onmessage = async (event)=>{
            const data = JSON.parse(event.data);
            await this.HandleManifest(data);
        };
        eventSource.onopen = ()=>{
            this.sseEventsEstablished = true;
        };
        eventSource.onerror = ()=>{
            this.sseEventsEstablished = false;
        };
    }
    async ReadFullPart(collectionName, part, idFieldsFromManifest) {
        const response = await fetch($d6bb929f44edcadb$var$ROOT_URL + this.collectionId + '/data/' + part.full);
        const json = await response.json();
        const change = {
            upsert: json,
            delete: []
        };
        this.DataReceived(collectionName, change, true, idFieldsFromManifest);
    }
    async AnalyzePart(collectionName, part) {
        if (part.data.length == 0) return;
        let lastPartHandled = null;
        if (this.lastPartHandled.has(collectionName)) lastPartHandled = this.lastPartHandled.get(collectionName);
        const lastPartFromBackend = part.data[part.data.length - 1];
        if (lastPartHandled == null || lastPartFromBackend.delta == '' && lastPartFromBackend.full != lastPartHandled.full) // Read the full data
        await this.ReadFullPart(collectionName, lastPartFromBackend, part.id);
        else {
            // Find changes between last seen and the last from backend
            let needsFullReload = false;
            let add = false;
            let needToHandle = [];
            for(let i = 0; i < part.data.length; ++i){
                if (add) {
                    needToHandle.push(part.data[i]);
                    if (part.data[i].delta == '') {
                        needsFullReload = true;
                        break;
                    }
                }
                if (part.data[i].full == lastPartHandled.full) add = true;
            }
            if (!add) // We did not see our last handled file, so we need a full reload.
            needsFullReload = true;
            // Are any of these full reload?
            if (needsFullReload) await this.ReadFullPart(collectionName, lastPartFromBackend, part.id);
            else {
                let promises = [];
                for(let i = 0; i < needToHandle.length; ++i)promises.push({
                    index: i,
                    promise: fetch($d6bb929f44edcadb$var$ROOT_URL + this.collectionId + '/data/' + needToHandle[i].delta)
                });
                for (const row of promises){
                    const response = await row.promise;
                    const json = await response.json();
                    this.DataReceived(collectionName, json, false, part.id);
                }
            }
        }
        this.lastPartHandled.set(collectionName, lastPartFromBackend);
    }
    fnv1a32(input) {
        let hash = 0x811c9dc5; // 32-bit offset basis
        for(let i = 0; i < input.length; i++){
            hash ^= input.charCodeAt(i);
            hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }
        return hash >>> 0;
    }
    async HandleManifest(data) {
        this.hashOfLastManifest = this.fnv1a32(JSON.stringify(data)).toString();
        let secondsSinceLastChange = Number.MAX_VALUE;
        let promises = [];
        for (const val of this.collectionsToTrigger){
            if (!(val in data)) continue;
            const part = data[val];
            const nowUnixSec = Date.now() / 1000;
            secondsSinceLastChange = Math.min(secondsSinceLastChange, nowUnixSec - part.last_modified);
            promises.push(this.AnalyzePart(val, part));
        }
        await Promise.all(promises);
        return secondsSinceLastChange;
    }
    async GetData() {
        let interval = 10000;
        try {
            const manifestFileName = Number.isNaN($d6bb929f44edcadb$var$forcedInterval) ? 'manifest' : 'manifest-nocache';
            const response = await fetch($d6bb929f44edcadb$var$ROOT_URL + this.collectionId + '/' + manifestFileName + '?hash=' + this.hashOfLastManifest);
            const data = await response.json();
            const secondsSinceLastChange = await this.HandleManifest(data);
            if (secondsSinceLastChange < 60 && !this.sseEventsEstablished) interval = 2000;
            else if (secondsSinceLastChange < 600) interval = 5000;
        } catch (ex) {
        // Silently accept errors so that setTimeout still gets called below.
        }
        if (!Number.isNaN($d6bb929f44edcadb$var$forcedInterval)) interval = $d6bb929f44edcadb$var$forcedInterval * 1000;
        if (!this.killed) setTimeout(this.GetData.bind(this), interval);
    }
}

});

parcelRegister("gizSK", function(module, exports) {

$parcel$export(module.exports, "UpdateLanguage", () => $6ee0bd0e1b8c5627$export$cd8262c65a48a6de);
$parcel$export(module.exports, "GetInitialLanguage", () => $6ee0bd0e1b8c5627$export$e7fb88a05713a1bd);

var $jlXLs = parcelRequire("jlXLs");
function $6ee0bd0e1b8c5627$export$b07951cf25661cc1(language_code) {
    switch(language_code.toLowerCase()){
        case 'en':
        case 'en-us':
        case 'en-gb':
            return $6ee0bd0e1b8c5627$var$en_US;
        default:
            return $6ee0bd0e1b8c5627$var$nb_NO;
    }
}
function $6ee0bd0e1b8c5627$export$cd8262c65a48a6de(language, initialPageLoad) {
    const newLanguage = $6ee0bd0e1b8c5627$export$b07951cf25661cc1(language);
    if (!initialPageLoad) {
        $6ee0bd0e1b8c5627$export$44ba23bac88e64b2(newLanguage.code);
        if (window.history) window.history.replaceState(null, null, (0, $jlXLs.ModifyQueryParameter)(location.href, 'lang', newLanguage.code));
    }
    for (const element of document.querySelectorAll('[data-i18n]')){
        const key = element.dataset.i18n;
        element.innerHTML = newLanguage[key];
    }
    return newLanguage;
}
function $6ee0bd0e1b8c5627$export$e7fb88a05713a1bd() {
    // The priority is as follows:
    // 1) URL query parameter: ....&lang=en-us
    // 2) Local storage: key "language"
    // 3) Browser setting: navigator.language
    // 4) nb-NO: We assume most users are norwegian
    const urlParams = new URLSearchParams(window.location.search);
    const languageUrl = urlParams.get('lang');
    if (languageUrl !== null) return $6ee0bd0e1b8c5627$export$b07951cf25661cc1(languageUrl);
    let languageLocalStorage = localStorage.getItem('lang');
    if (languageLocalStorage !== null) return $6ee0bd0e1b8c5627$export$b07951cf25661cc1(languageLocalStorage);
    return $6ee0bd0e1b8c5627$export$b07951cf25661cc1(navigator.language);
}
function $6ee0bd0e1b8c5627$export$44ba23bac88e64b2(language) {
    localStorage.setItem('lang', language);
}
const $6ee0bd0e1b8c5627$var$nb_NO = {
    code: 'nb-NO',
    index_race_description: 'Arrangement',
    index_race_type: 'Idrett',
    index_race_organizer: "Arrang\xf8r",
    index_race_date: 'Dato',
    index_race_maintained_by: 'Driftet av',
    index_buy_liveresults: 'Liveresultater.no for deg eller din klubb? Klikk her for mer info',
    index_buy_liveresults_header: "F\xe5 tilgang til liveresultater.no",
    index_buy_liveresults_line1: "N\xe5 kan du eller din klubb kj\xf8pe \xe5rsabonnement p\xe5 liveresultater.no! For 500,- eks. mva. per \xe5r vil du f\xe5:",
    index_buy_liveresults_listitem1: 'Tilgang til ubegrenset antall arrangement',
    index_buy_liveresults_listitem2: 'Lagring av lister og dokumenter direkte i livesenteret',
    index_buy_liveresults_listitem3: "Tilgang til v\xe5rt brikkesjekk-system",
    index_buy_liveresults_listitem4: "St\xf8tte for eTiming (SQL/Access) og Brikkesys",
    index_buy_liveresults_listitem5: 'Tilgang til streaming av arenalyd',
    index_buy_liveresults_listitem6: 'Og enda mer',
    index_buy_liveresults_contact: "For mer informasjon, ta kontakt p\xe5 epost",
    livecenter_heading: 'Livesenter',
    livecenter_organizer_homepage: "Arrang\xf8rens hjemmeside",
    livecenter_pm: 'PM',
    livecenter_video_stream: 'Videostreaming',
    livecenter_audio_not_supported: "Nettleseren din st\xf8tter ikke lydavspilling",
    livecenter_audio_to_be_started: "Arenalyd er annonsert, og vil bli tilgjengelig n\xe5r lydstreamen er startet",
    livecenter_audio_autostart: "Start arenalyd automatisk n\xe5r den blir tilgjengelig",
    livecenter_start_audio: 'Start arenalyd',
    livecenter_stop_audio: 'Stopp arenalyd',
    livecenter_audio_stopped: 'Arenalyd er stoppet',
    livecenter_audio_player_heading: 'Arenalyd',
    livecenter_audio_player_subheading: '(Oppdater siden hvis lyden stopper underveis)',
    livecenter_official_lists_heading: 'Offisielle lister',
    livecenter_official_lists_subheading: "Lister kommer s\xe5 snart de er klare",
    livecenter_gps_heading: 'GPS-tracking',
    livecenter_external_pages_heading: 'Eksterne linker',
    livecenter_audio_could_not_load: "Klarer ikke \xe5 laste arenalyd",
    livecenter_audio_loading: "Pr\xf8ver \xe5 laste arenalyd",
    livecenter_audio_loaded: 'Arenalyd spiller av',
    livecenter_live_results_subheading: '(alle liveresultater er uoffisielle)',
    livecenter_live_results_heading: 'Live Resultater',
    race_race_info_header: "L\xf8psinformasjon",
    race_description: 'Arrangement',
    race_organizer: "Arrang\xf8r",
    race_date: 'Dato',
    race_messages: 'Meldinger',
    race_legs: 'Etapper',
    race_classes: 'Klasser',
    race_clubs: 'Klubber',
    race_favourites: 'Favoritter',
    race_place: 'Plass',
    race_bib: 'St.nr',
    race_leg: 'Etp.',
    race_team: 'Lag',
    race_name: 'Navn',
    race_class_name: 'Klasse',
    race_club_name: 'Klubb',
    race_starttime: 'Starttid',
    race_chip_number: 'Brikkenr.',
    race_used_time: 'Tid',
    race_difference: 'Diff.',
    race_used_time_leg: 'Etappetid',
    race_used_time_leg_ridderuka: 'Bruttotid',
    race_shootings: 'Bom',
    race_export_excel: 'Eksport excel',
    race_first_page: "F\xf8rste",
    race_last_page: 'Siste',
    race_no_runners: "Ingen l\xf8pere",
    race_add_favourites: "Legg til l\xf8pere ved \xe5 klikke p\xe5 l\xf8perens navn",
    race_all_classes: 'Alle klasser',
    race_sprint_prolog_suffix: 'prolog',
    race_sprint_finals_suffix: 'finaler',
    race_all_classes_table_heading: 'Alle klasser',
    race_unknown_class_table_heading: 'Ukjent',
    race_favourites_table_heading: 'Favoritter',
    race_all_legs_table_heading: 'alle etapper',
    race_leg_table_heading: 'etappe',
    race_startlist_table_heading: 'startliste',
    race_finish_table_heading: "m\xe5l",
    race_combined_list_table_heading: 'kombinert liste',
    race_intermediate_code_table_heading: 'kode',
    race_stats_one_runner: "1 l\xf8per",
    race_stats_multiple_runners: "l\xf8pere",
    race_stats_runners_remaining: "gjenv\xe6rende",
    race_all_legs: 'Alle',
    race_startlist: 'Startliste',
    race_finish: "M\xe5l",
    race_combined_list: 'Kombinert liste',
    race_show_all_runners: 'Alle',
    free_start: 'fristart',
    no_event_today: "Ingen l\xf8p i dag",
    num_runners_front_label: 'Vis ',
    num_runners_back_label: " l\xf8pere"
};
const $6ee0bd0e1b8c5627$var$en_US = {
    code: 'en-US',
    index_race_description: 'Description',
    index_race_type: 'Sport',
    index_race_organizer: 'Organizer',
    index_race_date: 'Date',
    index_race_maintained_by: 'Maintained by',
    index_buy_liveresults: 'Liveresultater.no for you or your organisation? Click here for more information',
    index_buy_liveresults_header: 'Get access to liveresultater.no',
    index_buy_liveresults_line1: 'You or your organisation can now buy an annual subscription for liveresultater.no! For just 500 NOK excl. VAT. per year, you will get:',
    index_buy_liveresults_listitem1: 'Unlimited number of events',
    index_buy_liveresults_listitem2: 'Storage of lists and documents directly in our livecenter',
    index_buy_liveresults_listitem3: 'Access to our timing chip check system',
    index_buy_liveresults_listitem4: 'Support for eTiming (SQL/Access) and Brikkesys',
    index_buy_liveresults_listitem5: 'Access to audio streaming',
    index_buy_liveresults_listitem6: 'And more',
    index_buy_liveresults_contact: 'For more information, send an email to',
    livecenter_heading: 'Livecenter',
    livecenter_organizer_homepage: 'Organizer homepage',
    livecenter_pm: 'Event info',
    livecenter_video_stream: 'Video stream',
    livecenter_audio_not_supported: 'Your browser does not support audio streaming',
    livecenter_audio_to_be_started: 'Audio streaming is announced, and will be available once the stream has started',
    livecenter_audio_autostart: 'Start audio stream automatically once it\'s available',
    livecenter_start_audio: 'Start audio stream',
    livecenter_stop_audio: 'Stop audio stream',
    livecenter_audio_stopped: 'Audio stream is stopped',
    livecenter_audio_player_heading: 'Audio stream',
    livecenter_audio_player_subheading: '(Refresh the page if the audio stream stops)',
    livecenter_official_lists_heading: 'Official lists',
    livecenter_official_lists_subheading: 'Lists will be available when ready',
    livecenter_gps_heading: 'GPS tracking',
    livecenter_external_pages_heading: 'External pages',
    livecenter_audio_could_not_load: 'Could not load audio stream',
    livecenter_audio_loading: 'Loading audio stream',
    livecenter_audio_loaded: 'Audio stream is playing',
    livecenter_live_results_subheading: '(all live results are unofficial)',
    livecenter_live_results_heading: 'Live results',
    race_race_info_header: 'Race info',
    race_description: 'Description',
    race_organizer: 'Organizer',
    race_date: 'Date',
    race_messages: 'Messages',
    race_legs: 'Legs',
    race_classes: 'Classes',
    race_clubs: 'Clubs',
    race_favourites: 'Favourites',
    race_place: 'Place',
    race_bib: 'Bib',
    race_leg: 'Leg',
    race_team: 'Team',
    race_name: 'Name',
    race_class_name: 'Class',
    race_club_name: 'Club',
    race_starttime: 'Starttime',
    race_chip_number: 'Chip number',
    race_used_time: 'Time',
    race_difference: 'Diff.',
    race_used_time_leg: 'Leg time',
    race_used_time_leg_ridderuka: 'Gross time',
    race_shootings: 'Shootings',
    race_export_excel: 'Export excel',
    race_first_page: 'First',
    race_last_page: 'Last',
    race_no_runners: 'No runners',
    race_add_favourites: 'Add runners by clicking on their name',
    race_all_classes: 'All classes',
    race_sprint_prolog_suffix: 'prolog',
    race_sprint_finals_suffix: 'finals',
    race_all_classes_table_heading: 'All classes',
    race_unknown_class_table_heading: 'Unkown',
    race_favourites_table_heading: 'Favourites',
    race_all_legs_table_heading: 'all legs',
    race_leg_table_heading: 'leg',
    race_startlist_table_heading: 'startlist',
    race_finish_table_heading: 'finish',
    race_combined_list_table_heading: 'combined list',
    race_intermediate_code_table_heading: 'code',
    race_stats_one_runner: '1 runner',
    race_stats_multiple_runners: 'runners',
    race_stats_runners_remaining: 'remaining',
    race_all_legs: 'All',
    race_startlist: 'Startlist',
    race_finish: 'Finish',
    race_combined_list: 'Combined list',
    race_show_all_runners: 'All',
    free_start: 'free start',
    no_event_today: 'No event today',
    num_runners_front_label: 'Show ',
    num_runners_back_label: ' runners'
};

});
parcelRegister("jlXLs", function(module, exports) {

$parcel$export(module.exports, "EnsureAllIntermediatePointsArePresent", () => $d1fd75a6f5fa6dae$export$3113dc42d1e3a4b3);
$parcel$export(module.exports, "ModifyQueryParameter", () => $d1fd75a6f5fa6dae$export$5b252707a6de31fb);
$parcel$export(module.exports, "IsNullOrWhitespace", () => $d1fd75a6f5fa6dae$export$eeba3a4d7f7fd7b1);

var $2NT5D = parcelRequire("2NT5D");
function $d1fd75a6f5fa6dae$var$AddBlankIntermediateTime(runner, code) {
    runner.times[code] = {
        difference: null,
        passing_time: null,
        place: null,
        running_difference: null,
        running_place: null,
        running_time: null,
        used_time: null,
        used_time_leg: null
    };
}
function $d1fd75a6f5fa6dae$export$3113dc42d1e3a4b3(runners, allIntermediatePoints) {
    let intermediatePointLookup = {};
    for (const intermediatePoint of allIntermediatePoints){
        if (!(intermediatePoint.class_id in intermediatePointLookup)) intermediatePointLookup[intermediatePoint.class_id] = {};
        let legNumber = 1;
        if (intermediatePoint.leg_number !== null) legNumber = intermediatePoint.leg_number;
        if (!(legNumber in intermediatePointLookup[intermediatePoint.class_id])) intermediatePointLookup[intermediatePoint.class_id][legNumber] = {};
        intermediatePointLookup[intermediatePoint.class_id][legNumber][intermediatePoint.code] = intermediatePoint;
    }
    for (let runner of runners){
        if (!(runner.class_id in intermediatePointLookup)) intermediatePointLookup[runner.class_id] = {};
        let legNumber = 1;
        if (runner.leg_number !== null) legNumber = runner.leg_number;
        if (!(legNumber in intermediatePointLookup[runner.class_id])) intermediatePointLookup[runner.class_id][legNumber] = {};
        // for (const code in runner.times) {
        //     if (code == FINISH_CODE) {
        //         continue;
        //     }
        //     if (!(code in intermediatePointLookup[runner.class_id][legNumber])) {
        //         delete runner.times[code];
        //     }
        // }
        for(const code in intermediatePointLookup[runner.class_id][legNumber])if (!(code in runner.times)) $d1fd75a6f5fa6dae$var$AddBlankIntermediateTime(runner, code);
        if (!((0, $2NT5D.FINISH_CODE) in runner.times)) $d1fd75a6f5fa6dae$var$AddBlankIntermediateTime(runner, (0, $2NT5D.FINISH_CODE));
    }
}
function $d1fd75a6f5fa6dae$export$5b252707a6de31fb(fullUrl, key, value) {
    const idx = fullUrl.indexOf('?');
    if (idx == -1) return fullUrl + '?' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
    let params = new URLSearchParams(fullUrl.substring(idx));
    params.set(key, value);
    return fullUrl.substring(0, idx) + '?' + params.toString();
}
function $d1fd75a6f5fa6dae$export$eeba3a4d7f7fd7b1(str) {
    if (str === null) return true;
    for (const c of str){
        if (c != ' ') return false;
    }
    return true;
}

});
parcelRegister("2NT5D", function(module, exports) {

$parcel$export(module.exports, "RunnerStatus", () => $b7fe61732b3c81dc$export$766ab6d409115f1d);
$parcel$export(module.exports, "START_CODE", () => $b7fe61732b3c81dc$export$24f44cfb7d990db);
$parcel$export(module.exports, "FINISH_CODE", () => $b7fe61732b3c81dc$export$1318157ac50eaa36);
$parcel$export(module.exports, "COMBINED_CODE", () => $b7fe61732b3c81dc$export$d67d80f451226e0);
var $b7fe61732b3c81dc$export$766ab6d409115f1d = /*#__PURE__*/ function(RunnerStatus) {
    RunnerStatus[RunnerStatus["OK"] = 1] = "OK";
    RunnerStatus[RunnerStatus["REGISTERED"] = 2] = "REGISTERED";
    RunnerStatus[RunnerStatus["DSQ"] = 3] = "DSQ";
    RunnerStatus[RunnerStatus["DNF"] = 4] = "DNF";
    RunnerStatus[RunnerStatus["DNS"] = 5] = "DNS";
    RunnerStatus[RunnerStatus["NC"] = 6] = "NC";
    return RunnerStatus;
}({});
const $b7fe61732b3c81dc$export$24f44cfb7d990db = 'start';
const $b7fe61732b3c81dc$export$1318157ac50eaa36 = 'finish';
const $b7fe61732b3c81dc$export$d67d80f451226e0 = 'combined';

});



parcelRegister("fckDn", function(module, exports) {

$parcel$export(module.exports, "StartPingTimer", () => $39e10d5b7385079d$export$8eb6b68fb6d018d7);
const $39e10d5b7385079d$var$PING_INTERVAL = 60000; // Every minute
const $39e10d5b7385079d$var$sessionId = new BigUint64Array(1);
window.crypto.getRandomValues($39e10d5b7385079d$var$sessionId);
function $39e10d5b7385079d$export$8eb6b68fb6d018d7(page, extraData) {
    const url = 'https://ping.liveresultater.no/ping.php';
    const doPing = function() {
        const data = {
            'page': page,
            'referer': document.referrer,
            'session_id': $39e10d5b7385079d$var$sessionId[0].toString(),
            'extra_data': extraData()
        };
        let xmlHttp = new XMLHttpRequest();
        xmlHttp.open("POST", url);
        xmlHttp.send(JSON.stringify(data));
    };
    doPing();
    setInterval(doPing, $39e10d5b7385079d$var$PING_INTERVAL);
}

});


//# sourceMappingURL=web.df5bad77.js.map
